import API from './api';

export const getValorLiberadoCapitalFlow = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/busca-valor-liberado`);

export const getListaTitulosCessao = filtros =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-titulos-cessao`, { params: filtros });

export const getListaDeTipoOperacao = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-tipo-operacao`);

export const getListaTipoDocumento = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-tipo-documento`);

export const getEtapaCapitalFlow = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/busca-etapa-cessao`);

export const deleteRegistrosTemporarios = () =>
  API.delete(`${process.env.REACT_APP_API_HUB}/cessao/v1/delete-registros-temporarios`);

export const iniciarCessaoManual = params =>
  API.post(`${process.env.REACT_APP_API_HUB}/cessao/v1/iniciar-cessao-temp`, params);

export const getValorSolicitado = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/busca-valor-solicitado`);

export const iniciarCessaoSugestao = params =>
  API.post(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-titulo-sugestao-ia`, params);

export const getDadosResumoSimulacao = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-resumo-cessao`);

export const getDadosConsolidadosSacado = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-dados-consolidados-sacado`);

export const getDadosConsolidadosCedente = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-dados-consolidados-cedente`);

export const getTitulosResumoSelecao = params =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-titulos-resumo-selecao`, {
    params: params
  });

export const atualizarSelecaoTitulos = params =>
  API.post(`${process.env.REACT_APP_API_HUB}/cessao/v1/atualizar-selecao-titulos-cessao`, params);

export const atualizarEtapaCessao = params =>
  API.post(`${process.env.REACT_APP_API_HUB}/cessao/v1/atualizar-etapa-cessao`, params);

export const getTitulosSemDocumentos = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-titulos-sem-documento-cessao`);

export const listarArquivosTitulosCessao = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-arquivos-titulos-cessao`);

export const uploadArquivosTitulosCessao = (formData, onUploadProgress) =>
  API.post(`${process.env.REACT_APP_API_HUB}/cessao/v1/upload-arquivos-titulos-cessao`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress
  });

export const excluirArquivoTitulosCessao = uuid =>
  API.delete(`${process.env.REACT_APP_API_HUB}/cessao/v1/deletar-arquivo-titulos-cessao`, {
    params: {
      UUID: uuid
    }
  });

export const listarContasCorrentes = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-contas-correntes`);

export const listarBancos = () => API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-bancos`);

export const listarAgencias = codBanco =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-agencias-bancarias/${codBanco}`);

export const adicionarContaCorrente = params =>
  API.post(`${process.env.REACT_APP_API_HUB}/cessao/v1/adicionar-conta-corrente`, params);

export const aplicaSalvaContacorrente = params =>
  API.post(`${process.env.REACT_APP_API_HUB}/cessao/v1/salvar-conta-corrente`, params);

export const finalizaJornadaCessao = () =>
  API.post(`${process.env.REACT_APP_API_HUB}/cessao/v1/finalizar-cessao`);

export const getListarHistoricoCessoes = filtros =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-historico-cessoes`, { params: filtros });

export const getListaStatusOperacao = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-status-capital-flow`);

export const listarDetalhesCessao = uuid =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-detalhes-cessao/${uuid}`);

export const listarDadosHistorico = uuid =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-observacoes-cessao/${uuid}`);

export const listarDadosConsolidadosTitulos = uuid =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-consolidado-titulos-cedidos/${uuid}`);

export const listarDadosTitulosCedidos = (uuid, params) =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-titulos-cedidos/${uuid}`, {
    params: params
  });

export const obterArquivoRemessaCessao = uuid =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/obter-arquivo-remessa-cessao/${uuid}`);

export const atualizarStatusCessao = params =>
  API.post(`${process.env.REACT_APP_API_HUB}/cessao/v1/atualizar-status-cessao`, params);

export const validaTitulosCedidos = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/valida-titulos-cedidos`);

export const listarDadosDocumentosPendentes = uuid =>
  API.get(`${process.env.REACT_APP_API_HUB}/cessao/v1/listar-titulos-documentos-pendentes/${uuid}`);

export const uploadTitulosPendentes = (formData, onUploadProgress) =>
  API.post(`${process.env.REACT_APP_API_HUB}/cessao/v1/upload-arquivo-titulo-pendente`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress
  });

export const excluirArquivoTitulosPendentes = uuidTitulo =>
  API.delete(`${process.env.REACT_APP_API_HUB}/cessao/v1/excluir-arquivo-titulo-pendente/${uuidTitulo}`);
